import React, {ReactNode} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {EmojiCategoriesEnum} from '../../../../services/emojis/emojiList';

/*
 * Category name localization.
 */

type CategoryRenderers = {[T in EmojiCategoriesEnum]: ReactNode};
export const categoryRenderers: CategoryRenderers = {
  [EmojiCategoriesEnum.FREQUENTLY_USED]: <Trans id="emoji-frequentlyused">Frequently Used</Trans>,
  [EmojiCategoriesEnum.SMILEYS_AND_PEOPLE]: <Trans id="emoji-people">Smileys &amp; People</Trans>,
  [EmojiCategoriesEnum.ANIMALS_AND_NATURE]: <Trans id="emoji-nature">Animals &amp; Nature</Trans>,
  [EmojiCategoriesEnum.FOOD_AND_DRINK]: <Trans id="emoji-food">Food &amp; Drink</Trans>,
  [EmojiCategoriesEnum.ACTIVITY]: <Trans id="emoji-activity">Activity</Trans>,
  [EmojiCategoriesEnum.TRAVEL_AND_PLACES]: <Trans id="emoji-travel">Travel &amp; Places</Trans>,
  [EmojiCategoriesEnum.OBJECTS]: <Trans id="emoji-objects">Objects</Trans>,
  [EmojiCategoriesEnum.SYMBOLS]: <Trans id="emoji-symbols">Symbols</Trans>,
  [EmojiCategoriesEnum.FLAGS]: <Trans id="emoji-flags">Flags</Trans>,
  [EmojiCategoriesEnum.CUSTOM]: <Trans id="emoji-custom">Custom</Trans>,
};
